import React from 'react'
import { useTranslation } from 'react-i18next'
import { Caption, Text1 } from 'ui/shorthands/Texts'
import { BankTransfer } from 'types/med'
const BankInfo: React.FC<{ bankTransfer: BankTransfer }> = ({
  bankTransfer,
}) => {
  const { t } = useTranslation()
  return (
    <Text1>
      {t('金融機関名')}
      {'　'}
      {bankTransfer.bank_name}
      <br />
      {t('金融機関コード')}
      {'　'}
      {bankTransfer.bank_number}
      <br />
      {t('支店名')}
      {'　'}
      {bankTransfer.branch_name}
      <br />
      {t('支店番号')}
      {'　'}
      {bankTransfer.branch_number}
      <br />
      {t('預金種別')}
      {'　'}
      {bankTransfer.account_type}
      <br />
      {t('口座番号')}
      {'　'}
      {bankTransfer.account_number}
      <br />
      {t('口座名義')}
      {'　'}
      {bankTransfer.account_name}
      <br />
      <Caption>
        {t('振込期限')}
        :&nbsp;
        {bankTransfer.payment_deadline
          ? t('請求日から{{days}}日', { days: bankTransfer.payment_deadline })
          : t('なし')}
      </Caption>
      <br />
    </Text1>
  )
}
export default BankInfo
